module.exports = __webpack_public_path__ + "img/star-Icon.e21342c8.png";